import { useState } from 'react';
import { IPaymentField } from '../../interface/formInterface';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { handleSanitizeContent } from '../../utils/helper';
import { PaymentFormField } from './PaymentFormOptions';

const PaymentHelper = ({
  value,
  onChange,
  name,
}: {
  value: IPaymentField;
  onChange: (_value: IPaymentField) => void;
  name: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{name}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          {Object?.keys(value || {})?.map((key, index) => {
            return (
              <PaymentFormField
                key={key}
                name={key}
                value={value?.[key as keyof IPaymentField]}
                index={index}
                onChange={newValue => {
                  const sanitizedValue =
                    typeof newValue === 'string'
                      ? handleSanitizeContent(newValue)
                      : {
                          ...newValue,
                          placeholder: handleSanitizeContent(
                            newValue?.placeholder || '',
                          ),
                        };
                  onChange({ ...value, [key]: sanitizedValue });
                }}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

export default PaymentHelper;
